export default "dist/images/components-columns-width-control-2-2-uneven.59bd37a.png";